(() => {
  if (window.dtGiftDistributionReady) return;
  const dialog = document.getElementById('DTGiftDistribution');
  if (!dialog) return;
  window.dtGiftDistributionReady = true;
  const form = dialog.querySelector('form');
  const error = dialog.querySelector('[data-gift-error]');
  const details = dialog.querySelector('textarea');
  const custom = dialog.querySelector('[data-gift-custom]');
  const submit = dialog.querySelector('[type="submit"]');
  const strings = JSON.parse(document.getElementById('DTGiftStrings').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const keys = { mode: 'Preparación del regalo', details: 'Detalles de preparación del regalo' };
  const start = '[INICIO PREPARACIÓN REGALO DT]';
  const end = '[FIN PREPARACIÓN REGALO DT]';
  let active = null;
  let resume = null;
  let busy = false;
  let bypass = null;
  let previousFocus = null;
  let syncTimer;
  const returnKey = 'dt-gift-checkout-return-v1';
  let awaitingReturn = false;
  let approvedSignature = null;

  function rememberDeparture(state) {
    approvedSignature = state.signature;
    awaitingReturn = true;
    try { sessionStorage.setItem(returnKey, '1'); } catch (exception) {}
  }

  function consumeReturn() {
    let pending = awaitingReturn;
    awaitingReturn = false;
    try {
      pending ||= sessionStorage.getItem(returnKey) === '1';
      sessionStorage.removeItem(returnKey);
    } catch (exception) {}
    return pending;
  }

  function preparationAttributes(mode, instructions = '') {
    return {
      [keys.mode]: mode ? strings[mode] : '',
      [keys.details]: mode === 'custom' ? instructions : '',
      'Distribución del regalo': '',
      'DT distribución confirmada': ''
    };
  }

  function classify(context) {
    const groups = new Map();
    const extras = [];
    const metadata = new Map(context.lines.map(line => [line.key, line]));
    for (const item of context.cart.items) {
      const meta = metadata.get(item.key) || {};
      const properties = item.properties || {};
      const bundleId = properties._BS_bundleId || properties._BS_bundleid;
      const components = meta.components || [];
      const fixed = /^(pack\b|cesta\b)/i.test(meta.title || item.product_title || '');
      const box = meta.handle === 'caja-pack-2';
      const groupId = bundleId ? `bs:${bundleId}` : (components.length || fixed) ? `line:${item.key}` : null;
      if (groupId) {
        if (!groups.has(groupId)) groups.set(groupId, { items: [], gift: false, count: 1 });
        const group = groups.get(groupId);
        group.items.push(item);
        group.gift ||= fixed || box || components.some(component => component.handle === 'caja-pack-2');
        if (!bundleId) group.count = Number(item.quantity);
      } else {
        extras.push(item);
      }
    }
    const gifts = [...groups.values()].filter(group => group.gift);
    for (const group of groups.values()) if (!group.gift) extras.push(...group.items);
    const looseBoxes = extras.filter(item => metadata.get(item.key)?.handle === 'caja-pack-2');
    if (looseBoxes.length && groups.size && !gifts.length) {
      for (const group of groups.values()) {
        group.gift = true;
        gifts.push(group);
        for (const item of group.items) {
          const index = extras.indexOf(item);
          if (index >= 0) extras.splice(index, 1);
        }
      }
      for (const item of looseBoxes) extras.splice(extras.indexOf(item), 1);
    }
    const giftItems = gifts.flatMap(group => group.items);
    const signature = JSON.stringify(context.cart.items.map(item => [item.key, item.quantity]).sort((a, b) => a[0].localeCompare(b[0])));
    return { context, gifts, giftItems, extras, signature, applicable: gifts.length > 0 && extras.length > 0, multiple: gifts.reduce((sum, group) => sum + group.count, 0) > 1 || looseBoxes.reduce((sum, item) => sum + item.quantity, 0) > 1 };
  }

  function cleanNote(note) {
    const value = note || '';
    const begin = value.indexOf(start);
    if (begin < 0) return value;
    const finish = value.indexOf(end, begin);
    if (finish < 0) return value;
    return (value.slice(0, begin).trimEnd() + value.slice(finish + end.length)).trim();
  }

  function list(items) {
    return items.map(item => `${item.title} ×${item.quantity}`).join('\n');
  }

  async function read() {
    const url = new URL(`${root}cart`, window.location.origin);
    url.searchParams.set('section_id', 'dt-gift-cart-context');
    url.searchParams.set('_dt', Date.now());
    const response = await fetch(url, { cache: 'no-store', headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('cart-read');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = doc.querySelector('[data-dt-gift-context]');
    if (!node) throw new Error('cart-context');
    return classify(JSON.parse(node.textContent));
  }

  async function update(payload) {
    const response = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
    if (!response.ok) throw new Error('cart-save');
    const cart = await response.json();
    if (cart.status >= 400) throw new Error('cart-save');
    if (payload.note !== undefined) {
      document.querySelectorAll('cart-note textarea, textarea[name="note"]').forEach(input => { input.value = cart.note || ''; });
    }
    return cart;
  }

  function visibility(state) {
    document.documentElement.classList.toggle('dt-gift-needs-choice', state.applicable);
  }

  function show(state, message = '') {
    active = state;
    visibility(state);
    error.textContent = message;
    form.reset();
    custom.hidden = true;
    details.required = false;
    dialog.querySelector('[data-gift-intro]').textContent = state.multiple ? strings.multiple : strings.intro;
    dialog.querySelectorAll('[data-gift-simple]').forEach(label => { label.hidden = state.multiple; });
    dialog.querySelector('[data-gift-items]').textContent = list(state.extras);
    const saved = state.context.cart.attributes || {};
    const radio = [...form.querySelectorAll('[name="distribution"]')].find(input => strings[input.value] === saved[keys.mode]);
    if (radio && (!state.multiple || radio.value === 'custom')) {
      radio.checked = true;
      details.value = saved[keys.details] || '';
      custom.hidden = radio.value !== 'custom';
      details.required = radio.value === 'custom';
    }
    if (state.multiple) {
      form.querySelector('[value="custom"]').checked = true;
      custom.hidden = false;
      details.required = true;
    }
    previousFocus = document.activeElement;
    if (!dialog.open) dialog.showModal();
  }

  function setBusy(value) {
    busy = value;
    submit.disabled = value;
    submit.textContent = value ? strings.saving : strings.continue;
    dialog.querySelectorAll('[data-gift-close]').forEach(button => { button.disabled = value; });
    form.setAttribute('aria-busy', String(value));
  }

  async function clear(state) {
    const cart = state.context.cart;
    if (![keys.mode, keys.details, 'Distribución del regalo', 'DT distribución confirmada'].some(key => (cart.attributes || {})[key]) && !(cart.note || '').includes(start)) return;
    await update({ attributes: preparationAttributes(null), note: cleanNote(cart.note) });
  }

  function continueAction(action) {
    if (!action.target.isConnected) {
      const target = action.target.id ? document.getElementById(action.target.id) : null;
      if (!target) throw new Error('checkout-target');
      action = { target, run: () => {
        if (target.tagName !== 'FORM') { target.click(); return; }
        const button = document.querySelector('[name="checkout"]');
        if (button?.form === target) target.requestSubmit(button);
        else target.requestSubmit();
      } };
    }
    bypass = action.target;
    try { action.run(); } finally { bypass = null; }
  }

  async function intercept(action) {
    if (busy || dialog.open) return;
    resume = action;
    setBusy(true);
    try {
      const state = await read();
      visibility(state);
      const attrs = state.context.cart.attributes || {};
      if (!state.applicable) {
        await clear(state);
        continueAction(action);
      } else if (approvedSignature === state.signature && [strings.together, strings.separate, strings.custom].includes(attrs[keys.mode]) && (!state.multiple || attrs[keys.mode] === strings.custom) && (attrs[keys.mode] !== strings.custom || attrs[keys.details]?.trim())) {
        continueAction(action);
      } else {
        show(state);
      }
    } catch (exception) {
      error.textContent = strings.error;
      active = null;
      dialog.querySelector('[data-gift-intro]').textContent = strings.error;
      dialog.querySelectorAll('[data-gift-simple]').forEach(label => { label.hidden = true; });
      custom.hidden = true;
      dialog.querySelector('[data-gift-items]').textContent = '';
      previousFocus = document.activeElement;
      if (!dialog.open) dialog.showModal();
    } finally {
      setBusy(false);
    }
  }

  form.addEventListener('change', () => {
    const mode = form.querySelector('[name="distribution"]:checked')?.value;
    custom.hidden = mode !== 'custom';
    details.required = mode === 'custom';
    if (mode === 'custom') details.focus();
    error.textContent = '';
  });

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy) return;
    if (!active) {
      dialog.close();
      await intercept(resume);
      return;
    }
    const mode = form.querySelector('[name="distribution"]:checked')?.value;
    if (!mode || (mode === 'custom' && !details.value.trim())) { error.textContent = strings.required; return; }
    const instructions = details.value.trim();
    setBusy(true);
    try {
      const current = await read();
      if (current.signature !== active.signature) {
        show(current, strings.changed);
        return;
      }
      const payload = { attributes: preparationAttributes(mode, instructions) };
      if ((current.context.cart.note || '').includes(start)) payload.note = cleanNote(current.context.cart.note);
      const cart = await update(payload);
      const savedSignature = JSON.stringify(cart.items.map(item => [item.key, item.quantity]).sort((a, b) => a[0].localeCompare(b[0])));
      if (savedSignature !== current.signature) { show(await read(), strings.changed); return; }
      rememberDeparture(current);
      dialog.close();
      continueAction(resume);
    } catch (exception) {
      error.textContent = strings.error;
    } finally {
      setBusy(false);
    }
  });

  dialog.querySelectorAll('[data-gift-close]').forEach(button => button.addEventListener('click', () => { if (!busy) dialog.close(); }));
  dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  dialog.addEventListener('close', () => { previousFocus?.focus(); });

  window.addEventListener('click', event => {
    const target = event.target.closest?.('button[name="checkout"], input[name="checkout"], #CheckOut, a[href]');
    if (!target || target.disabled || target === bypass) return;
    if (target.tagName === 'A') {
      const url = new URL(target.href, location.href);
      if (url.origin !== location.origin || !/\/(checkout|checkouts)(\/|$)/.test(url.pathname)) return;
    }
    if (event.isTrusted) approvedSignature = null;
    event.preventDefault();
    event.stopImmediatePropagation();
    intercept({ target, run: () => target.click() });
  }, true);

  window.addEventListener('submit', event => {
    const target = event.target;
    if (target === form || target === bypass || event.submitter === bypass) return;
    const button = event.submitter;
    if (button?.name !== 'checkout' && button?.id !== 'CheckOut') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    intercept({ target, run: () => target.requestSubmit(button) });
  }, true);

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(() => { if (!busy && !dialog.open) read().then(visibility).catch(() => {}); }, 300);
  }
  const boot = document.querySelector('[data-dt-gift-context]');
  if (boot) { try { visibility(classify(JSON.parse(boot.textContent))); } catch (exception) { scheduleSync(); } }
  document.addEventListener('cart-updated', scheduleSync, true);
  document.addEventListener('krown:cart:update', scheduleSync, true);
  document.addEventListener('krown:cart:add', scheduleSync, true);
  const cartRoot = document.getElementById('AjaxCartForm');
  if (cartRoot) new MutationObserver(scheduleSync).observe(cartRoot, { childList: true, subtree: true });
  async function restoreCheckoutReturn() {
    approvedSignature = null;
    if (!consumeReturn()) { scheduleSync(); return; }
    if (dialog.open) dialog.close();
    setBusy(true);
    try {
      const state = await read();
      visibility(state);
      if (!state.applicable) { await clear(state); return; }
      const target = document.querySelector('#site-cart-sidebar button[name="checkout"], button[name="checkout"], input[name="checkout"], #CheckOut');
      if (!target || target.disabled) return;
      resume = { target, run: () => target.click() };
      const drawer = document.getElementById('site-cart-sidebar');
      if (typeof drawer?.show === 'function') drawer.show();
      show(state);
    } catch (exception) {
      scheduleSync();
    } finally {
      setBusy(false);
    }
  }
  window.addEventListener('pageshow', restoreCheckoutReturn);
  window.addEventListener('pagehide', () => { approvedSignature = null; });
  if (document.readyState === 'complete') restoreCheckoutReturn();
})();

